import { useOktaAuth } from "@okta/okta-react";
import { AuthState } from "@okta/okta-auth-js";
import { Tab, TabGroup } from "@nike/eds";
import { useNavigate } from "react-router-dom";
import React from "react";

function Navigation() {
    const { authState } = useOktaAuth();
    const [activeId, setActiveId] = React.useState(getCurrentTabId());
    const navigate = useNavigate();

    const handleTabChange = (e: React.SyntheticEvent<HTMLDivElement> & { target: { id: string } }) => {
        setActiveId(e.target.id);
        navigate("/" + e.target.id);
    };

    return (
        <TabGroup name="navigation" activeId={activeId} onChange={handleTabChange}>
            {hasAuthorizedGroup(authState, window.env.REACT_APP_GROUP_NAME_PRODUCT_WEIGHTS) && (
                <Tab id="product-weights">Product Weights</Tab>
            )}
        </TabGroup>
    )
}

function hasAuthorizedGroup(authState: AuthState | null, group: string) {
    const groups = extractAuthGroups(authState);
    if(Array.isArray(groups)) {
      return groups.includes(group);
    }

    return false;
}

function extractAuthGroups(authState: AuthState | null) {
    return authState?.idToken?.claims?.groups
}

function getCurrentTabId() {
    return window.location.pathname.split('/').pop();
}

export default Navigation;